<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import Loader from "../components/loader";
import moment from "moment/moment";
import api from "@/axios";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Movimento Mercado Livre",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      movMeliData: {
        id: 0,
      },
      movMeliItensData: null,
      movMeliEtiqsData: null,
      movData: null,
      idData: 0,
      updating: true,
      title: "Movimento Mercado Livre",
      items: [
        {
          text: "Comercial",
          href: "/pedido/dashmeli",
        },
        {
          text: "Movimento Mercado Livre",
          active: true,
        },
      ],
    };
  },

  methods: {

    consultarMov(){
      console.log('consultarMov')
      console.log(this.movData)
      if (this.movData) {
        const routeData = this.$router.resolve(`/movimento/editar/${this.movData.id}`)
        window.open(routeData.href, '_blank')
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Chave de movimento não encontrada.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    imprimir() {
      console.log('imprimir')
      this.updating = true

      api.get(`${getBaseUrl()}api/movmelimpr`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {
        console.log(res.data)
        console.log('res down')
        console.log(res)
        // var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        // var fileLink = document.createElement('a');
        // fileLink.href = fileURL;
        // fileLink.setAttribute('download', 'etiqueta');
        // document.body.appendChild(fileLink);
        // console.log('fileLink')
        // console.log(fileURL)
        // fileLink.click();

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Comando de impressão executado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.updating = false

      });


    },


    carregarDados(){
      console.log('carregarDados')

      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/movmeli`, {
          params: { iddata: this.idData }
        }).then((res) => {
          // console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.movMeliData = res.data[0]
            this.movMeliItensData = res.data[1]
            this.movMeliEtiqsData = res.data[2]
            this.movData = res.data[3]


            // console.log('this.movMeliData.dtemissao')
            // console.log(this.movMeliData.dtemissao)

            this.movMeliData.created_at = moment(this.movMeliData.created_at).format('DD/MM/YYYY HH:mm:ss')
            this.movMeliData.closed_at = moment(this.movMeliData.closed_at).format('DD/MM/YYYY HH:mm:ss')
            this.movMeliData.valid_at = moment(this.movMeliData.valid_at).format('DD/MM/YYYY HH:mm:ss')
            this.movMeliData.leadtime = moment(this.movMeliData.created_at).diff(moment(this.movMeliData.closed_at))


            this.idData = this.movMeliData.id
            this.title = `Movimento Mercado Livre (${this.movMeliData.idorigem}) ${this.movMeliData.nickname}`
            this.updating = false

            console.log('finalizou carrega movimento')

          }
        });
      }else{

        this.title = `Criando Novo Movimento`
        this.updating = false
      }

    },









    formatDecimal(value) {
      // return parseFloat(value).toFixed(2)
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value).toFixed(2)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
      }
      return "0,00"
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted_movimento_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    this.carregarDados()



  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movMeliData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating" >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-danger" class="mx-2" :disabled="true">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar
              </b-button>


              <b-button variant="outline-warning" class="mx-2" :disabled="true">
                <i class="bx bx-map-pin font-size-16 align-middle me-2" ></i>
                Rastreamento
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="imprimir" :disabled="!movMeliEtiqsData">
                <i class="bx bx-printer font-size-16 align-middle me-2" ></i>
                {{ movMeliEtiqsData !== null ? 'Imprimir Etiqueta' : 'Etiqueta Não Disponível' }}
              </b-button>


              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <!--              <button class="btn btn-success"-->
              <!--                      @click="confirmarOrcamento"-->
              <!--                      :disabled="movMeliData.status !== 'EL'"-->
              <!--                      v-if="movMeliData.status === 'EL' && orctoItensData && orctoItensData.length > 0">-->
              <!--                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!-->
              <!--              </button>-->


            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="checkout-tabs" v-if="!updating">


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-1
                      class="text-dark"
                      href="javascript: void(0);"
                  >Dados Principais</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2">

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="id">ID</label>
                        <input
                            id="id"
                            v-model="movMeliData.idorigem"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="ID"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="idship">ID (Shipping)</label>
                        <input
                            id="idship"
                            v-model="movMeliData.idship"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="ID (Shipping)"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="idcliente">ID (Cliente)</label>
                        <input
                            id="idcliente"
                            v-model="movMeliData.idcliente"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="ID (Cliente)"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="nome">Cliente</label>
                        <input
                            id="nome"
                            v-model="movMeliData.nome"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Cliente"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cnpj">CPF / CNPJ</label>
                        <input
                            id="cnpj"
                            v-model="movMeliData.cnpj"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="CPF / CNPJ"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="created_at">Data Criação</label>
                        <input
                            id="created_at"
                            v-model="movMeliData.created_at"
                            type="text"
                            class="form-control"
                            placeholder="Data Criação"
                            :disabled="true"/>
                      </div>
                    </div>

                  </div>


                  <div class="row mb-2">



<!--                    <div class="col-md-4">-->
<!--                      <div class="mb-3">-->
<!--                        <label for="chave">Chave Nota Fiscal</label>-->
<!--                        <input-->
<!--                            id="chave"-->
<!--                            v-model="movMeliData.chave"-->
<!--                            type="text"-->
<!--                            :disabled="true"-->
<!--                            class="form-control"-->
<!--                            placeholder="Chave Nota Fiscal"/>-->
<!--                      </div>-->
<!--                    </div>-->

                    <div class="col-sm-4">
                      <label for="chave">Chave Nota Fiscal</label>
                      <div class="position-relative">
                        <input
                            id="chave"
                            type="text"
                            v-model="movMeliData.chave"
                            class="form-control"
                            :disabled="true"
                            placeholder="Chave Nota Fiscal"/>

                        <div class="chat-input-links" v-if="movMeliData.chave">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a
                                  href="javascript: void(0);"
                                  v-b-tooltip.hover
                                  placement="top"
                                  @click="consultarMov"
                                  title="Consultar Movimento">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="valid_at">Data Validade</label>
                        <input
                            id="valid_at"
                            v-model="movMeliData.valid_at"
                            type="text"
                            class="form-control"
                            placeholder="Data Validade"
                            :disabled="true"/>
                      </div>
                    </div>



                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="closed_at">Data Fechamento</label>
                        <input
                            id="closed_at"
                            v-model="movMeliData.closed_at"
                            type="text"
                            class="form-control"
                            placeholder="Data Fechamento"
                            :disabled="true"/>
                      </div>
                    </div>

                  </div>



                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-2
                      class="text-dark"
                      href="javascript: void(0);"
                  >Resultados</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2" >

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="vlrtaxas">Valor Taxas</label>
                        <input
                            id="vlrtaxas"
                            v-model="movMeliData.vlrtaxas"
                            type="number"
                            class="form-control text-end"
                            placeholder="Valor Taxas"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="vlrfrete">Valor Frete</label>
                        <input
                            id="vlrfrete"
                            v-model="movMeliData.vlrfrete"
                            type="number"
                            class="form-control text-end"
                            placeholder="Valor Frete"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="vlrtotal">Valor Total</label>
                        <input
                            id="vlrtotal"
                            v-model="movMeliData.vlrtotal"
                            type="number"
                            class="form-control text-end"
                            placeholder="Valor Total"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="vlrpago">Valor Pago</label>
                        <input
                            id="vlrpago"
                            v-model="movMeliData.vlrpago"
                            type="number"
                            class="form-control text-end"
                            placeholder="Valor Pago"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="vlrlucro">Valor Lucro</label>
                        <input
                            id="vlrlucro"
                            v-model="movMeliData.vlrlucro"
                            type="number"
                            class="form-control text-end"
                            placeholder="Valor Lucro"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="margem">Margem</label>
                        <input
                            id="margem"
                            v-model="movMeliData.margem"
                            type="number"
                            class="form-control text-end"
                            placeholder="Margem"
                            :disabled="true"/>
                      </div>
                    </div>





                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-3
                      class="text-dark"
                      href="javascript: void(0);"
                  >Endereços</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2" >

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="ende">Endereço Entrega</label>
                        <input
                            id="ende"
                            v-model="movMeliData.ende"
                            type="text"
                            class="form-control"
                            placeholder="Endereço Entrega"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-1">
                      <div class="mb-3">
                        <label for="nume">Número</label>
                        <input
                            id="nume"
                            v-model="movMeliData.nume"
                            type="text"
                            class="form-control"
                            placeholder="Número"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="bairroe">Bairro</label>
                        <input
                            id="bairroe"
                            v-model="movMeliData.bairroe"
                            type="text"
                            class="form-control"
                            placeholder="Bairro"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cepe">CEP</label>
                        <input
                            id="cepe"
                            v-model="movMeliData.cepe"
                            type="text"
                            class="form-control"
                            placeholder="CEP"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cidadee">Cidade</label>
                        <input
                            id="cidadee"
                            v-model="movMeliData.cidadee"
                            type="text"
                            class="form-control"
                            placeholder="Cidade"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-1">
                      <div class="mb-3">
                        <label for="estadoe">Estado</label>
                        <input
                            id="estadoe"
                            v-model="movMeliData.estadoe"
                            type="text"
                            class="form-control"
                            placeholder="Estado"
                            :disabled="true"/>
                      </div>
                    </div>

                  </div>



                  <div class="row mb-2" >

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="endf">Endereço Faturamento</label>
                        <input
                            id="endf"
                            v-model="movMeliData.endf"
                            type="text"
                            class="form-control"
                            placeholder="Endereço Faturamento"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-1">
                      <div class="mb-3">
                        <label for="numf">Número</label>
                        <input
                            id="numf"
                            v-model="movMeliData.numf"
                            type="text"
                            class="form-control"
                            placeholder="Número"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="bairrof">Bairro</label>
                        <input
                            id="bairrof"
                            v-model="movMeliData.bairrof"
                            type="text"
                            class="form-control"
                            placeholder="Bairro"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cepf">CEP</label>
                        <input
                            id="cepf"
                            v-model="movMeliData.cepf"
                            type="text"
                            class="form-control"
                            placeholder="CEP"
                            :disabled="true"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="cidadef">Cidade</label>
                        <input
                            id="cidadef"
                            v-model="movMeliData.cidadef"
                            type="text"
                            class="form-control"
                            placeholder="Cidade"
                            :disabled="true"/>
                      </div>
                    </div>


                    <div class="col-md-1">
                      <div class="mb-3">
                        <label for="estadof">Estado</label>
                        <input
                            id="estadof"
                            v-model="movMeliData.estadof"
                            type="text"
                            class="form-control"
                            placeholder="Estado"
                            :disabled="true"/>
                      </div>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>



      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-5
                      class="text-dark"
                      href="javascript: void(0);"
                  >Itens do Pedido</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
                <b-card-body>

                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Origem</th>
                        <th scope="col">Código</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Categoria</th>
                        <th scope="col">Tipo</th>
                        <th scope="col" class="text-end">Quantidade</th>
                        <th scope="col" class="text-end">Vlr.Unit.</th>
                        <th scope="col" class="text-end">Vlr.Unit.(Full)</th>
                        <th scope="col" class="text-end">Vlr.Taxas</th>
                        <th scope="col" class="text-end">Vlr.Lucro</th>
                        <th scope="col" class="text-end">Margem(%)</th>
                        <th scope="col" class="text-end">Vlr.Total</th>

                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="item in movMeliItensData" :key="item.id">
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <a class="text-dark"
                               href="javascript: void(0);">
                              {{ item.id }}
                            </a>
                          </h5>
                        </td>
                        <td class="text-muted mb-0">{{ item.idorigem }}</td>
                        <td class="text-muted mb-0">{{ item.codcustom }}</td>
                        <td class="text-muted mb-0">{{ item.descricao }}</td>
                        <td class="text-muted mb-0">{{ item.categoria }}</td>
                        <td class="text-muted mb-0">{{ item.tipolista }}</td>
                        <td class="text-muted mb-0 text-end">{{ formatDecimal(item.quant) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrunit) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrunitfull) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrtaxas) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrlucro) }}</td>
                        <td class="text-end">{{ formatDecimal(item.margem) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrtotal) }}</td>


                      </tr>

                      </tbody>
                    </table>
                  </div>



                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>



    </div>




  </Layout>
</template>

<style>

</style>

